<template>
  <div class="previewimg-bd" v-if="isShow">
    <div class="modal" @click="closePreview()">
      <div class="image-box">
        <img class="center" :src="imageUrl" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imageUrl: '',
      isShow: true,
    };
  },
  mounted: function () {},
  methods: {
    closePreview: function () {
      this.isShow = false;
    },
  },
};

</script>
<style lang="scss">
.previewimg-bd {
  .modal {
    z-index: 99
  }
  .image-box {
    position: relative;
    width: 100%;
    height: 100%;
    img {
      display: block;
      width: 98%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/preview.vue